import React, { useCallback, useEffect, useState } from "react";
import PageTitle from "../../Module/pageTitle";
import LabelField from "../../Component/labelField";
import InputField from "../../Component/inputField";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AddMorebtn from "../../Component/addMoreBtn";
import ImagePickerAndViewer from "../../Component/imagePickerAndViewer";
import TextEditor from "../DataEntryPanel/CreateQuestion/textEditor";
import CustomDropdown from "../../Component/customDropdown";
import { pdf_size_1MB, validateIsFileImageType } from "../../Utils/validators";
import { useDispatch } from "react-redux";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import { validateIsFileImageTypeErrMsg } from "../../Utils/errorMsg";
import {
  addContactUs,
  getContactUs,
  uploadContactImg,
} from "../../Action/courseAction";
import SubmitButton from "../../Component/SubmitButton";
import HtmlTextEditor from "../../Component/HtmlTextEditor";

const AddGetContactUs = () => {
  const dispatch = useDispatch();
  const initialGetIn = [{ title: "", contact: "", description: "" }];
  const initialSection = [
    {
      icon: "",
      selectedIcon: "",
      title: "",
      desc: "",
      seoName: "",
      orders: "",
      faq: [
        {
          question: "",
          answer: [
            {
              type: "",
              content: "",
              selectedContent: "",
              order: "",
            },
          ],
        },
      ],
    },
  ];
  const [state, setState] = useState({
    getInTouch: {
      title: "",
      description: "",
      contact: initialGetIn,
    },
    section: initialSection,
  });
  const updateState = (key) => setState((prev) => ({ ...prev, ...key }));

  const onAddMore = useCallback(
    (key, ...arg) => {
      const [sectionIndex, faqIndex] = arg;
      const newArr = [...state?.section];
      if (key === "getInTouch") {
        updateState({
          getInTouch: {
            ...state?.getInTouch,
            contact: [...state?.getInTouch?.contact, initialGetIn[0]],
          },
        });
      } else if (key === "section") {
        updateState({ section: [...state?.section, initialSection[0]] });
      } else if (key === "faq") {
        const tempArr = newArr[sectionIndex]["faq"];
        newArr[sectionIndex].faq = [
          ...tempArr,
          {
            question: "",
            answer: [
              {
                type: "",
                content: "",
                order: "",
              },
            ],
          },
        ];
        updateState({
          section: newArr,
        });
      } else if (key === "answer") {
        const tempArr = newArr[sectionIndex]["faq"][faqIndex].answer;
        newArr[sectionIndex].faq[faqIndex].answer = [
          ...tempArr,
          {
            type: "",
            content: "",
            order: "",
          },
        ];
        updateState({
          section: newArr,
        });
      }
    },
    [state?.getInTouch, state?.section]
  );

  const onClose = useCallback(
    (key, ...arg) => {
      const [index, faqIndex, answerIndex] = arg;
      const newArr =
        key === "getInTouch"
          ? [...state?.getInTouch?.contact]
          : [...state?.section];
      if (key === "getInTouch" || key === "section") {
        if (index > -1) newArr?.splice(index, 1);
        key === "getInTouch"
          ? updateState({
              getInTouch: { ...state?.getInTouch, contact: newArr },
            })
          : updateState({ section: newArr });
      }
      if (key === "faq") {
        if (faqIndex > -1) {
          newArr[index].faq.splice(faqIndex, 1);
        }
        updateState({ section: newArr });
      } else if (key === "answer") {
        if (faqIndex > -1) {
          newArr[index].faq[faqIndex].answer.splice(answerIndex, 1);
        }
        updateState({ section: newArr });
      }
    },
    [state?.section, state?.getInTouch]
  );

  const onChangeGetInTouch = (value, index, key) => {
    const newArr = JSON.parse(JSON.stringify(state?.getInTouch?.contact));
    newArr[index][key] = value;
    updateState({
      getInTouch: {
        ...state?.getInTouch,
        contact: newArr,
      },
    });
  };

  const onChangeSection = (value, index, faqIndex, answerIndex, key) => {
    const newArr = JSON.parse(JSON.stringify(state?.section));

    if (key === "title") {
      newArr[index][key] = value;
      updateState({ section: newArr });
    } else if (key === "desc") {
      newArr[index][key] = value;
      updateState({ section: newArr });
    } else if (key === "desc") {
      newArr[index][key] = value;
      updateState({ section: newArr });
    } else if (key === "icon") {
      value.preventDefault();
      if (!validateIsFileImageType(value)) {
        dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
        return;
      }
      // if (value.target.files[0].size > pdf_size_1MB) {
      //   dispatch(showErrorSnackbar("File size should be less than 1 MB !!!"));
      // }
      else {
        const newArr = JSON.parse(JSON.stringify(state?.section));
        const reader = new FileReader();
        const file = value.target.files[0];
        reader.onloadend = () => {
          dispatch(
            uploadContactImg(file, (res) => {
              newArr[index][key] = res?.url;
              newArr[index].selectedIcon = reader.result;
              updateState({ section: newArr });
            })
          );
          updateState({ section: newArr });
        };
        reader.readAsDataURL(file);
      }
    } else if (key === "seoName") {
      newArr[index][key] = value;
      updateState({ section: newArr });
    } else if (key === "orders") {
      newArr[index][key] = value;
      updateState({ section: newArr });
    } else if (key === "question") {
      newArr[index]["faq"][faqIndex][key] = value;
      updateState({ section: newArr });
    } else if (key === "type") {
      newArr[index]["faq"][faqIndex]["answer"][answerIndex][key] = value?._id;
      updateState({ section: newArr });
    } else if (key === "order") {
      newArr[index]["faq"][faqIndex]["answer"][answerIndex][key] = value;
      updateState({ section: newArr });
    } else if (key === "content") {
      if (newArr[index]["faq"][faqIndex]["answer"][answerIndex]["type"] === 1) {
        newArr[index]["faq"][faqIndex]["answer"][answerIndex][key] = value;
        updateState({ section: newArr });
      } else if (
        newArr[index]["faq"][faqIndex]["answer"][answerIndex]["type"] === 2
      ) {
        value.preventDefault();

        if (!validateIsFileImageType(value)) {
          dispatch(showErrorSnackbar(validateIsFileImageType));
          return;
        }
        // if (value.target.files[0].size > pdf_size_1MB) {
        //   dispatch(showErrorSnackbar("File size should be less than 1 MB !!!"));
        // }
        else {
          const newArr = JSON.parse(JSON.stringify(state?.section));
          const reader = new FileReader();
          const file = value.target.files[0];
          reader.onloadend = () => {
            dispatch(
              uploadContactImg(file, (res) => {
                newArr[index]["faq"][faqIndex]["answer"][answerIndex][key] =
                  res?.url;
                newArr[index]["faq"][faqIndex]["answer"][answerIndex][
                  "selectedContent"
                ] = reader.result;

                updateState({ section: newArr });
              })
            );
          };
          reader.readAsDataURL(file);
        }
      }
    }
    // newArr[index][key] = value;
    // updateState({ section: newArr });
  };
  const onChangeSection1 = (value, index, faqIndex, answerIndex, key) => {};
  const onChangeSectionImage = (e, index, faqIndex, answerIndex, key) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    // if (e.target.files[0].size > pdf_size_1MB) {
    //   dispatch(showErrorSnackbar("File size should be less than 1 MB !!!"));
    // }
    else {
      const newArr = JSON.parse(JSON.stringify(state?.section));

      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        dispatch(
          uploadContactImg(file, (res) => {
            newArr[index][key] = res?.url;
            newArr[index].selectedIcon = reader.result;
            updateState({ section: newArr });
          })
        );
        updateState({ section: newArr });
      };
      reader.readAsDataURL(file);
    }
    // ************************************************************************
    // else {
    //   const newArr = JSON.parse(JSON.stringify(state?.section));
    //   const reader = new FileReader();
    //   const file = e.target.files[0];
    //   reader.onloadend = () => {
    //     dispatch(
    //       uploadContactImg(file, (res) => {
    //         newArr[sectionIndex].faq[faqIndex].answer[answerIndex].content =
    //           res?.url;
    //         newArr[sectionIndex].faq[faqIndex].answer[
    //           answerIndex
    //         ].selectedContent = reader.result;
    //         updateState({ section: newArr });
    //       })
    //     );
    //   };
    //   reader.readAsDataURL(file);
    // }
  };
  const onChangeFaqSection = (value, sectionIndex, key, faqIndex) => {
    const newArr = [...state?.section];
    newArr[sectionIndex]["faq"][faqIndex][key] = value;
    updateState({ section: newArr });
  };
  const onChangeFaqAnswerSection = (
    value,
    sectionIndex,
    key,
    faqIndex,
    answerIndex
  ) => {
    const newArr = [...state?.section];
    if (key === "type") {
      newArr[sectionIndex].faq[faqIndex].answer[answerIndex][key] = value?._id;
      updateState({ section: newArr });
    }
    if (key === "order") {
      newArr[sectionIndex].faq[faqIndex].answer[answerIndex][key] = value;
      updateState({ section: newArr });
    }
    if (key === "content") {
      newArr[sectionIndex].faq[faqIndex].answer[answerIndex][key] = value;
      updateState({ section: newArr });
    }
    // else {
    //
    //   newArr[sectionIndex].faq[faqIndex].answer[answerIndex][key] = value;
    //   updateState({ section: newArr });
    // }
  };
  const onChangeFaqAnswerSectionImage = (
    e,
    sectionIndex,
    key,
    faqIndex,
    answerIndex
  ) => {
    e.preventDefault();
    if (key === "content") {
      if (!validateIsFileImageType(e)) {
        dispatch(showErrorSnackbar(validateIsFileImageType));
        return;
      }
      // if (e.target.files[0].size > pdf_size_1MB) {
      //   dispatch(showErrorSnackbar("File size should be less than 1 MB !!!"));
      // }
      else {
        const newArr = JSON.parse(JSON.stringify(state?.section));
        const reader = new FileReader();
        const file = e.target.files[0];
        reader.onloadend = () => {
          dispatch(
            uploadContactImg(file, (res) => {
              // newArr[sectionIndex].faq[faqIndex].answer[answerIndex].content =
              //   res?.url;
              newArr[sectionIndex].faq[faqIndex].answer[answerIndex][key] =
                res?.url;
              newArr[sectionIndex].faq[faqIndex].answer[
                answerIndex
              ].selectedContent = reader.result;
              updateState({ section: newArr });
            })
          );
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const renderGetInTouch = () => {
    return (
      <div className="col-md-12">
        <div className="d-flex col-md-12">
          <LabelField labelName={"Get in Touch"} />
          <div className="card rounded p-2 mb-2 position-relative">
            <div className="card-body">
              <div className="col-md-12">
                <InputField
                  labelName={"Title"}
                  placeholder={"Enter Title"}
                  setInputText={(value) =>
                    updateState({
                      getInTouch: {
                        ...state.getInTouch,
                        title: value,
                      },
                    })
                  }
                  value={state?.getInTouch?.title}
                />
              </div>
              <div className="col-md-12">
                <InputField
                  labelName={"Description"}
                  placeholder={"Enter Description"}
                  setInputText={(value) =>
                    updateState({
                      getInTouch: {
                        ...state.getInTouch,
                        description: value,
                      },
                    })
                  }
                  value={state?.getInTouch?.description}
                />
              </div>
              <div className="d-flex col-md-12">
                <LabelField labelName="Contact" />
                <div>
                  {state?.getInTouch?.contact?.map((item, index) => {
                    const { title, contact, description } = item;
                    return (
                      <div
                        key={index}
                        className="card rounded p-2 mb-2 position-relative"
                      >
                        <span className="d-flex justify-content-end removeButton">
                          {state?.getInTouch?.contact?.length === 1 ? null : (
                            <HighlightOffIcon
                              className="cursor"
                              color="primary"
                              fontSize="small"
                              onClick={() => onClose("getInTouch", index)}
                            />
                          )}
                        </span>
                        <div className="col-md-12 card-body">
                          <InputField
                            labelName={`Title ${index > 0 ? index + 1 : ""}`}
                            placeholder={"Enter Title"}
                            setInputText={(value) =>
                              onChangeGetInTouch(value, index, "title")
                            }
                            value={title}
                          />
                          <InputField
                            labelName={`Contact ${index > 0 ? index + 1 : ""}`}
                            placeholder={"Enter Contact"}
                            setInputText={(value) =>
                              onChangeGetInTouch(value, index, "contact")
                            }
                            value={contact}
                            maxlength={10}
                          />
                          <InputField
                            labelName={`Description ${
                              index > 0 ? index + 1 : ""
                            }`}
                            placeholder={"Enter Description"}
                            setInputText={(value) =>
                              onChangeGetInTouch(value, index, "description")
                            }
                            value={description}
                          />
                        </div>
                      </div>
                    );
                  })}
                  <div className="col-auto d-flex justify-content-end mt-4">
                    <AddMorebtn handleClick={() => onAddMore("getInTouch")} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSection = () => {
    return (
      <div className="col-md-12">
        <div className="d-flex col-md-11">
          <LabelField labelName={"Section"} />
          <div className="mb-2 position-relative">
            {state?.section?.map((sectionItem, sectionIndex) => {
              const { icon, title, desc, seoName, orders, faq, selectedIcon } =
                sectionItem;
              return (
                <div
                  key={sectionIndex}
                  className="card position-relative mb-2 p-2"
                >
                  <span className="d-flex justify-content-end removeButton">
                    {state?.section?.length === 1 ? null : (
                      <HighlightOffIcon
                        className="cursor"
                        color="primary"
                        fontSize="small"
                        onClick={() => onClose("section", sectionIndex)}
                      />
                    )}
                  </span>
                  <div className="card-body col-md-12">
                    <InputField
                      labelName={"Title"}
                      placeholder={"Enter Title"}
                      setInputText={(val) =>
                        onChangeSection(val, sectionIndex, "", "", "title")
                      }
                      value={title}
                    />
                    <InputField
                      labelName={"Description"}
                      placeholder={"Enter Description"}
                      setInputText={(val) =>
                        onChangeSection(val, sectionIndex, "", "", "desc")
                      }
                      value={desc}
                    />
                    <ImagePickerAndViewer
                      labelName={"Image"}
                      value={selectedIcon || icon}
                      // handleChange={(e) => {
                      //   onChangeSectionImage(e, sectionIndex ,"", "","icon");
                      // }}
                      handleChange={(e) => {
                        onChangeSection(e, sectionIndex, "", "", "icon");
                      }}
                      // htmlFor={`photo upload${sectionIndex + 1}`}
                    />

                    <InputField
                      labelName={"Seo Name"}
                      placeholder={"Enter Seo Name"}
                      setInputText={(val) =>
                        onChangeSection(val, sectionIndex, "", "", "seoName")
                      }
                      value={seoName}
                    />
                    <InputField
                      labelName={"Order"}
                      placeholder={"Enter Order"}
                      setInputText={(val) =>
                        onChangeSection(val, sectionIndex, "", "", "orders")
                      }
                      value={orders}
                    />
                    <div className="d-flex col-md-11">
                      <LabelField labelName={"FAQ"} />
                      <div className="mb-2 position-relative">
                        {faq?.map((faqItem, faqIndex) => {
                          const { question, answer } = faqItem;
                          return (
                            <div
                              key={faqIndex}
                              className="card position-relative mb-2 p-2"
                            >
                              <span className="position-absolute top-0 end-0">
                                {faq?.length === 1 ? null : (
                                  <HighlightOffIcon
                                    className="cursor"
                                    color="primary"
                                    fontSize="small"
                                    onClick={() =>
                                      onClose("faq", sectionIndex, faqIndex)
                                    }
                                  />
                                )}
                              </span>
                              <div className="card-body col-md-12">
                                <InputField
                                  labelName={"Question"}
                                  placeholder={"Enter Question"}
                                  // setInputText={(val) =>
                                  //   onChangeFaqSection(
                                  //     val,
                                  //     sectionIndex,
                                  //     "question",
                                  //     faqIndex
                                  //   )
                                  // }
                                  setInputText={(val) =>
                                    onChangeSection(
                                      val,
                                      sectionIndex,
                                      faqIndex,
                                      "",
                                      "question"
                                    )
                                  }
                                  value={question}
                                />
                                <div className="d-flex col-md-11">
                                  <LabelField labelName="Answer" />
                                  <div className="mb-2 position-relative">
                                    {answer?.map((answerItem, answerIndex) => {
                                      const {
                                        _id,
                                        type,
                                        content,
                                        order,
                                        selectedContent,
                                      } = answerItem;
                                      return (
                                        <div
                                          key={
                                            _id ||
                                            `${sectionIndex}-${faqIndex}-${answerIndex}`
                                          }
                                          className="card position-relative mb-2 p-2"
                                        >
                                          <div className="card-body  col-md-12">
                                            <span className="position-absolute top-0 end-0">
                                              {answer?.length === 1 ? null : (
                                                <HighlightOffIcon
                                                  className="cursor"
                                                  color="primary"
                                                  fontSize="small"
                                                  onClick={() =>
                                                    onClose(
                                                      "answer",
                                                      sectionIndex,
                                                      faqIndex,
                                                      answerIndex
                                                    )
                                                  }
                                                />
                                              )}
                                            </span>
                                            <div className="d-flex mb-2  align-items-center">
                                              <LabelField
                                                labelName={"Answer Type"}
                                              />
                                              <div style={{ width: "400px" }}>
                                                <CustomDropdown
                                                  setInputText={(val) =>
                                                    // onChangeFaqAnswerSection(
                                                    //   value,
                                                    //   sectionIndex,
                                                    //   "type",
                                                    //   faqIndex,
                                                    //   answerIndex
                                                    // )
                                                    onChangeSection(
                                                      val,
                                                      sectionIndex,
                                                      faqIndex,
                                                      answerIndex,
                                                      "type"
                                                    )
                                                  }
                                                  options={[
                                                    { _id: 1, name: "Text" },
                                                    { _id: 2, name: "Image" },
                                                  ]}
                                                  labelName={
                                                    "Select Anser Type"
                                                  }
                                                  defaultValue={type}
                                                  value={type}
                                                />
                                              </div>
                                            </div>
                                            <InputField
                                              labelName={"Order"}
                                              placeholder={"Enter Order"}
                                              setInputText={(val) =>
                                                // onChangeFaqAnswerSection(
                                                //   val,
                                                //   sectionIndex,
                                                //   "order",
                                                //   faqIndex,
                                                //   answerIndex
                                                // )
                                                onChangeSection(
                                                  val,
                                                  sectionIndex,
                                                  faqIndex,
                                                  answerIndex,
                                                  "order"
                                                )
                                              }
                                              value={order}
                                            />
                                            {type === 1 ? (
                                              <div className="d-flex mb-2 align-items-center">
                                                <LabelField
                                                  labelName={"Answer"}
                                                />
                                                <TextEditor
                                                  setInputText={(val) =>
                                                    // onChangeFaqAnswerSection(
                                                    //   value,
                                                    //   sectionIndex,
                                                    //   "content",
                                                    //   faqIndex,
                                                    //   answerIndex
                                                    // )
                                                    onChangeSection(
                                                      val,
                                                      sectionIndex,
                                                      faqIndex,
                                                      answerIndex,
                                                      "content"
                                                    )
                                                  }
                                                  value={content}
                                                />
                                                {/* <HtmlTextEditor
                                                  onChange={(val) =>
                                                    onChangeSection(
                                                      val,
                                                      sectionIndex,
                                                      faqIndex,
                                                      answerIndex,
                                                      "content"
                                                    )
                                                  }
                                                  value={content}
                                                  height={"10vh"}
                                                  width={"40vw"}
                                                /> */}
                                              </div>
                                            ) : type === 2 ? (
                                              <ImagePickerAndViewer
                                                labelName={"Image"}
                                                value={
                                                  selectedContent || content
                                                }
                                                handleChange={(val) => {
                                                  // onChangeFaqAnswerSectionImage(
                                                  //   e,
                                                  //   sectionIndex,
                                                  //   "content",

                                                  //   faqIndex,
                                                  //   answerIndex
                                                  // );
                                                  onChangeSection(
                                                    val,
                                                    sectionIndex,
                                                    faqIndex,
                                                    answerIndex,
                                                    "content"
                                                  );
                                                }}
                                                // htmlFor={`photo upload${sectionIndex + faqIndex + answerIndex + 2
                                                //   }`}
                                              />
                                            ) : null}
                                          </div>
                                        </div>
                                      );
                                    })}
                                    <div className="col-auto d-flex justify-content-end mt-4">
                                      <AddMorebtn
                                        handleClick={() =>
                                          onAddMore(
                                            "answer",
                                            sectionIndex,
                                            faqIndex
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        <div className="col-auto d-flex justify-content-end mt-4">
                          <AddMorebtn
                            handleClick={() => onAddMore("faq", sectionIndex)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="col-auto d-flex justify-content-end mt-4">
              <AddMorebtn handleClick={() => onAddMore("section")} />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const getInTouchValidation = () => {
    const { contact } = state?.getInTouch;
    let result = false;
    contact?.forEach((itm) => {
      if (itm?.title === "" || itm?.contact === "" || itm?.description === "") {
        result = true;
      }
    });
    return result;
  };
  const sectionValidation = () => {
    const { section } = state;

    const isBlank = (value) =>
      value === "" || value === undefined || value === null;

    const validateObject = (obj) => {
      for (const key in obj) {
        if (key === "selectedContent") continue;

        const value = obj[key];
        if (isBlank(value)) return true;

        if (Array.isArray(value) && value.some(validateObject)) return true;

        if (
          typeof value === "object" &&
          value !== null &&
          validateObject(value)
        ) {
          return true;
        }
      }
      return false;
    };
    return section.some(validateObject);
  };

  const validation = () => {
    const { title, description } = state?.getInTouch || {};
    return (
      !title || !description || getInTouchValidation() || sectionValidation()
    );
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const { getInTouch, section } = state;
    const removeFields = (obj) => {
      if (Array.isArray(obj)) {
        return obj.map(removeFields);
      }
      if (typeof obj === "object" && obj !== null) {
        return Object.keys(obj).reduce((acc, key) => {
          if (
            key !== "selectedContent" &&
            key !== "selectedIcon" &&
            key !== "_id"
          ) {
            acc[key] = removeFields(obj[key]);
          }
          return acc;
        }, {});
      }
      return obj;
    };
    const newGetSection = removeFields(getInTouch);
    const newSection = removeFields(section);
    const reqBody = {
      contactData: {
        getInTouch: newGetSection,
        section: newSection,
      },
    };
    dispatch(
      addContactUs(reqBody, (resp) => {
        if (resp) {
          updateState({ getInTouch: resp?.getInTouch, section: resp?.section });
        }
      })
    );
  };
  useEffect(() => {
    dispatch(
      getContactUs((resp) => {
        if (resp) {
          updateState({ getInTouch: resp?.getInTouch, section: resp?.section });
        }
      })
    );
  }, []);
  return (
    <div className="contentBox">
      <PageTitle name={"CONTACT US"} />
      <div className="col formDiv ">
        <div className="col-12 formWidth">
          <form onSubmit={handleSubmit}>
            {renderGetInTouch()}
            {renderSection()}
            <div className="col-auto d-flex justify-content-center">
              <SubmitButton name="Submit" validations={validation()} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddGetContactUs;
